var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Topbar", { ref: "topbar" }),
      _c(
        "div",
        {
          staticClass: "m-auto breadcrumb-container",
          staticStyle: { "padding-top": "30px", "padding-bottom": "30px" },
        },
        [_c("Breadcrumb", { ref: "breadcrumb", attrs: { title: "公告详情" } })],
        1
      ),
      _c("div", { staticClass: "m-auto news details-text" }, [
        _c("div", { staticClass: "news-title" }, [
          _vm._v(_vm._s(_vm.detailsInfo.name)),
        ]),
        _c("div", { staticClass: "news-marks" }, [
          _c("div", { staticClass: "news-label size-16" }, [
            _c("div", [
              _vm._v(_vm._s(_vm._f("fmDate")(_vm.detailsInfo.createTime))),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "flex justify-between text-#909099 size-16" },
            [
              _c("div", { staticClass: "newstext-size" }, [
                _vm._v(" 字号: "),
                _c(
                  "div",
                  {
                    staticClass: "size-small",
                    class: _vm.fontSize === "small" ? "news-size" : "",
                    on: {
                      click: function ($event) {
                        _vm.fontSize = "small"
                      },
                    },
                  },
                  [_vm._v(" 小 ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "size-middle",
                    class: _vm.fontSize === "middle" ? "news-size" : "",
                    on: {
                      click: function ($event) {
                        _vm.fontSize = "middle"
                      },
                    },
                  },
                  [_vm._v(" 中 ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "size-big",
                    class: _vm.fontSize === "big" ? "news-size" : "",
                    on: {
                      click: function ($event) {
                        _vm.fontSize = "big"
                      },
                    },
                  },
                  [_vm._v(" 大 ")]
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "mb-40px" }, [
          _vm.fontSize === "small"
            ? _c("div", {
                staticClass: "text-html text-html-small p-line-height",
                staticStyle: { "font-size": "16px" },
                domProps: { innerHTML: _vm._s(_vm.detailsInfo.content) },
              })
            : _vm.fontSize === "middle"
            ? _c("div", {
                staticClass: "text-html text-html-middle p-line-height",
                staticStyle: { "font-size": "18px" },
                domProps: { innerHTML: _vm._s(_vm.detailsInfo.content) },
              })
            : _c("div", {
                staticClass: "text-html text-html-big p-line-height",
                staticStyle: { "font-size": "20px" },
                domProps: { innerHTML: _vm._s(_vm.detailsInfo.content) },
              }),
          _vm.detailsInfo.video &&
          (_vm.detailsInfo.content === null ||
            _vm.detailsInfo.content === "" ||
            _vm.detailsInfo.content.indexOf("video") === -1)
            ? _c(
                "div",
                [
                  _c("Video", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: _vm.detailsInfo.m4v,
                      poster: _vm.detailsInfo.picLinks,
                      left: "45%",
                      bottom: "45%",
                    },
                    on: { hidden: _vm.hiddenTitle },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }